/**
 * Hook reativo de `window.matchMedia`. Usado para escolher variantes de layout
 * que o CSS sozinho não resolve — ex.: um componente portalado (Sheet do Radix)
 * que escapa do `lg:hidden` do container e precisa NÃO ser montado no desktop.
 */
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** `true` a partir do breakpoint `lg` do Tailwind (1024px). */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)');
}
